import React, { Component, ErrorInfo, ReactNode } from 'react';

import ErrorLogo from '../../assets/images/error.svg';

import classes from './ErrorBoundary.module.scss';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className={classes.content}>
          <div>
            <img src={ErrorLogo} alt="error accured" />
          </div>
          <div>
            <div className={classes.title}>Oh my...</div>
            <div className={classes.description}>Something went wrong.</div>
            <div className={classes.description}>
              Could you try refreshing the page?
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
